import { render, staticRenderFns } from "./GSelectItemList.vue?vue&type=template&id=3de8fae9&scoped=true&"
import script from "./GSelectItemList.vue?vue&type=script&lang=ts&"
export * from "./GSelectItemList.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectItemList.vue?vue&type=style&index=0&id=3de8fae9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8fae9",
  null
  
)

export default component.exports